import { useDevice } from "@hooks/useDevice";
import type { ItemResponse } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import ItemResponseForm from "components/ItemResponseForm";

type Props = {
	itemResponse: Extract<ItemResponse, { type: "form" }>;
	countryCode?: string;
	updateFormStates: (formStates: Record<string, string>) => void;
	disabled?: boolean;
	currentUserResponse?: Record<string, string>;
};

const NoteCompletion = ({
	itemResponse,
	countryCode,
	updateFormStates,
	disabled = false,
	currentUserResponse,
}: Props) => {
	const { isMobile, isMediumWindowSize } = useDevice();

	return (
		<Box paddingHorizontal={isMobile || isMediumWindowSize ? 16 : 0}>
			<ItemResponseForm
				formConfig={itemResponse}
				onWatch={updateFormStates}
				countryCode={countryCode}
				disabled={disabled}
				userResponse={currentUserResponse}
			/>
		</Box>
	);
};

export default NoteCompletion;
